import {
  Avatar,
  Button,
  Dropdown,
  Popconfirm,
  Space,
  Table,
  TableColumnsType,
  message,
} from 'antd';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import { Member } from '../../../ types';
import { StagesStore } from '../../../../DataSource/Stores/Cabinet/StagesStore';
import { WorkspacesStore } from '../../../../DataSource/Stores/Cabinet/WorkspacesStore';
import LayoutStore from '../../../../DataSource/Stores/LayoutStore';
import { config } from '../../../../config';
import uWS from '../../../../uWS';
import { $class } from '../../../../utils';
import Icon from '../../../ui/Icon';
import IconButton from '../../../ui/IconButton';
import * as styles from './index.module.scss';

const Members: React.FC = () => {
  const { id: workspaceId } = useParams();

  useEffect(() => {
    if (!workspaceId) return;

    (async () => {
      try {
        const res = await WorkspacesStore.membersGet.call(workspaceId);
        WorkspacesStore.setMembers(res.data);
      } catch (e: any) {
        console.error(e);
        toast.error(e.message.message);
      }

      try {
        const res = await WorkspacesStore.getJobsInWork.call(workspaceId);
        WorkspacesStore.setInWorkJobs(res.data);
      } catch (e: any) {
        console.error(e);
        toast.error(e.message.message);
      }

      await StagesStore.getList(workspaceId);
    })();
  }, [workspaceId]);

  useEffect(() => {
    if (!workspaceId) return;

    const eventStatus = uWS.subscribe(`workspaces/${workspaceId}/userOnline`, (data: any) => {
      if (data.error) {
        console.error('Error subscribing to workspace user online:', data.error);
        return;
      }

      (async () => {
        try {
          const res = await WorkspacesStore.membersGet.call(workspaceId);
          WorkspacesStore.setMembers(res.data);
        } catch (e: any) {
          console.error(e);
          toast.error(e.message.message);
        }

        try {
          const res = await WorkspacesStore.getJobsInWork.call(workspaceId);
          WorkspacesStore.setInWorkJobs(res.data);
        } catch (e: any) {
          console.error(e);
          toast.error(e.message.message);
        }

        await StagesStore.getList(workspaceId);
      })();
    });

    return () => {
      if (eventStatus) uWS.unSubscribe(`workspaces/${workspaceId}/userOnline`);
    };
  }, [workspaceId]);

  const deleteMember = async (userId: string) => {
    if (!workspaceId) return;

    try {
      await WorkspacesStore.memberDel.call(workspaceId, userId);
      const res = await WorkspacesStore.membersGet.call(workspaceId);
      WorkspacesStore.setMembers(res.data);
      message.success('Курьер удален');
    } catch (e: any) {
      message.error(e.message.message);
    }
  };

  const columns: TableColumnsType<Member> = [
    {
      title: 'Имя',
      dataIndex: 'firstname',
      key: 'firstname',
      render: (_, record: Member) => (
        <div className={styles.nameBlock}>
          {record.userId.photo && (
            <Avatar
              src={`${config.EXTERNAL_ADDRESS}/image-uploader/${record.userId.photo}`}
              shape="circle"
              size={40}
            />
          )}
          {!record.userId.photo && <div className={styles.photo}>{record.userId.firstname[0]}</div>}
          <div>
            <p className={styles.name}>{record.userId.firstname}</p>
            <div
              className={$class(
                styles.status,
                [styles.online, record.onlineStatus === 'online'],
                [styles.offline, record.onlineStatus === 'offline'],
                [styles.inactive, record.onlineStatus === 'inactive']
              )}
            >
              <div />
              {record.onlineStatus}
            </div>
          </div>
        </div>
      ),
    },

    {
      title: 'Фамилия',
      dataIndex: 'secondname',
      key: 'secondname',
      render: (_, record: Member) => (
        <div className={styles.nameBlock}>
          <p className={styles.name}>{record.userId.secondname}</p>
        </div>
      ),
    },
    {
      title: 'E-mail',
      dataIndex: 'userId.email',
      key: 'userId.email',
      render: (_, record: Member) => <>{record.userId.email}</>,
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: (_, record: Member) => (
        <div className={styles.statusBlock}>
          <div></div>
          {record.userId.status}
        </div>
      ),
    },

    {
      key: '4',
      render: (_: string, record: any) => (
        <Dropdown
          menu={{
            items: [
              {
                key: '1',
                danger: true,
                label: (
                  <Popconfirm
                    title="Bы действительно хотите удалить пользователя?"
                    okText="Да"
                    cancelText="Нет"
                    onConfirm={() => {
                      deleteMember(record._id);
                    }}
                  >
                    <div>Удалить</div>
                  </Popconfirm>
                ),
              },
            ],
          }}
          trigger={['click']}
        >
          <IconButton icon="three_dots" variant="secondary" />
        </Dropdown>
      ),
    },
  ];

  return (
    <div className={styles.membersPage}>
      <div className={styles.membersPageTop}>
        <div className={styles.title}>Управление курьерами</div>

        <Button
          onClick={() => LayoutStore.openModal('workspaceAddMember', { workspaceId })}
          className={styles.but_neword}
        >
          <Icon slug={'fi-rr-plus'} />
        </Button>
      </div>

      <div className={styles.tabl_bl + ' tabl_bl'}>
        <Space className={styles.tabl_bl__buttons + ' tabl_bl__buttons'}>
          <p className={styles.title}>Все курьеры</p>
        </Space>
        <Table
          className={styles.table}
          columns={columns}
          dataSource={Object.values(WorkspacesStore.members)}
          loading={WorkspacesStore.membersGet.loading}
          pagination={{ position: ['topRight'] }}
          rowKey="_id"
          sticky={{ offsetHeader: 0 }}
        />
      </div>
    </div>
  );
};

export default observer(Members);
